"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitionConditionPlugins = void 0;
const CheckDependenciesPlugin_1 = require("./CheckDependenciesPlugin");
const CheckSubTasksPlugin_1 = require("./CheckSubTasksPlugin");
const CheckTeamPlugin_1 = require("./CheckTeamPlugin");
const ConfirmPlugin_1 = require("./ConfirmPlugin");
const RequiredFieldsPlugin_1 = require("./RequiredFieldsPlugin");
const SignaturePlugin_1 = require("./SignaturePlugin");
/**
 * Register transition condition plugins in this array
 */
exports.transitionConditionPlugins = [
    RequiredFieldsPlugin_1.RequiredFieldsPlugin,
    ConfirmPlugin_1.ConfirmPlugin,
    SignaturePlugin_1.SignaturePlugin,
    CheckSubTasksPlugin_1.CheckSubTasksPlugin,
    CheckTeamPlugin_1.CheckTeamPlugin,
    CheckDependenciesPlugin_1.CheckDependenciesPlugin
];
exports.default = exports.transitionConditionPlugins;
//# sourceMappingURL=default.js.map